export default {
  title: 'Luo API-avain',
  reveal_warning: 'Tallenna tämä avain nyt — sitä ei näytetä uudelleen.',
  form: {
    name: 'Nimi',
    name_placeholder: 'esim. Tuotantoavain',
  },
  buttons: {
    cancel: 'Peruuta',
    create: 'Luo',
    done: 'Valmis',
  },
  toasts: {
    error: 'Avainta ei voitu luoda. Yritä uudelleen.',
  },
};
